export default {
      id: "logo-text_rus-usage",
      viewBox: "0 0 129 30",
      url: __webpack_public_path__ + "sprite.svg#logo-text_rus",
      toString: function () {
        return this.url;
      }
    }